export default "__VITE_ASSET__ICUWrTyu__"